import type { ReactNode } from 'react'
import { cn } from '@ludus/ui'

/**
 * Hoisted to `shared/` once a second feature needed it, mirroring the
 * `<Breadcrumb>` hoist.
 */
export interface CenteredPanelProps {
  title: string
  body?: string
  meta?: string
  tone?: 'error'
  muted?: boolean
  children?: ReactNode
}

export function CenteredPanel({ title, body, meta, tone, muted, children }: CenteredPanelProps) {
  const accent =
    tone === 'error' ? 'text-toast-error-text' : muted ? 'text-muted' : 'text-foreground'
  return (
    <div className="flex h-full w-full flex-1 items-center justify-center p-8">
      <div className="bg-gradient-panel-elevated flex max-w-md flex-col gap-2 rounded-lg border border-border/40 px-5 py-4 text-foreground shadow-[0_24px_48px_-32px_rgba(0,0,0,0.7)]">
        <span className={cn('text-[11px] font-semibold uppercase tracking-[0.16em]', accent)}>
          {title}
        </span>
        {body && <p className="text-sm text-muted">{body}</p>}
        {meta && (
          <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-muted/70">
            {meta}
          </span>
        )}
        {children && <div className="mt-2 flex items-center gap-2">{children}</div>}
      </div>
    </div>
  )
}
